import { testimonials } from '@/mocks/homeData';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-label uppercase tracking-[2px] text-foreground-500 whitespace-nowrap">User Stories</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight max-w-2xl mx-auto">
            Trusted By 10,000+
            <br />
            Fashion Hunters
          </h2>
          <p className="text-foreground-500 text-sm mt-4 max-w-md mx-auto">
            Real feedback from the Superbuy Sheet community of organized shoppers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-7 md:p-8 flex flex-col"
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-lg"></i>
                ))}
              </div>
              <h4 className="text-foreground-950 text-base font-label font-semibold mb-3 leading-snug">
                {t.headline}
              </h4>
              <p className={`text-sm leading-relaxed mb-6 flex-1 ${idx >= 3 ? 'text-foreground-400' : 'text-foreground-600'}`}>
                {t.body}
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-secondary-800 text-sm font-label font-semibold">
                    {t.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-foreground-900 text-sm font-label font-semibold whitespace-nowrap">{t.author}</p>
                  <p className="text-foreground-400 text-xs whitespace-nowrap">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}